import { Form } from 'antd';
import { Button, Colors, IcPlus, InputSearch, Row, Text } from 'basic-ui-lib';
import { useCallback } from 'react';
import styled from 'styled-components';
import useGetListChannels from 'modules/channel/services/hooks/useGetListChannels';
import useDebounce from 'hooks/useDebounce';
import { useNavigate } from 'react-router-dom';

const PlaylistFilter = () => {
  const [form] = Form.useForm();
  const [, mutate] = useGetListChannels(true);
  const navigate = useNavigate();

  const onSearchDebounce = useCallback((value: string) => {
      mutate({ from: 1, size: 10, keySearch: value });
  }, []);

  const { text: searchText, setText: setSearchText } = useDebounce({
    timeDebounce: 600,
    onDebounce: onSearchDebounce,
  });

  const handleCreateNewPlaylist = () => {
    navigate('/playlist/create');
  };

  return (
    <Container>
      <Form form={form} layout='vertical' className='form-container'>
        <Row width='45%'>
          <Text title_h2 semibold>
            Playlists 
          </Text>
        </Row>
        <Row gap={16} width='55%' justifyContent='flex-end'>
          <Form.Item name='keySearch' noStyle>
            <InputSearch placeholder='Search playlist name' value={searchText} onChange={(value) => setSearchText(value)} />
          </Form.Item>
          <Button type_second lg type='button' prefix={<IcPlus fill={Colors.neutral.bg[1]} width={20} height={20} />} onClick={handleCreateNewPlaylist}>
            New Playlist
          </Button>
        </Row>
      </Form>
      {/* <NewPlaylistModal isOpen={open} onClose={() => setOpen(false)} /> */}
    </Container>
  );
};

export default PlaylistFilter;

const Container = styled.div`
  width: 100%;

  .form-container {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .custom-text {
    white-space: nowrap;
  }
`;
